import { render, staticRenderFns } from "./panKuZD.vue?vue&type=template&id=3be123e7&scoped=true&"
import script from "./panKuZD.vue?vue&type=script&lang=js&"
export * from "./panKuZD.vue?vue&type=script&lang=js&"
import style0 from "./panKuZD.vue?vue&type=style&index=0&id=3be123e7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3be123e7",
  null
  
)

export default component.exports